document.addEventListener("DOMContentLoaded", () => {
  Fancybox.bind("[data-fancybox]", {});
  Fancybox.bind('[data-fancybox="gallery"]', {});

  let count_slides_video_testimonials = 4;
  if (window.innerWidth <= 1024) {
    count_slides_video_testimonials = 3;
  }
  $(".custom--video-testimonials").each((i, e) => {
    if ($(e).find(".carousel-cell").length <= count_slides_video_testimonials) {
      $(e).find(".slider-arrows").remove();
      $(e).addClass("no-slider");
    }
  });
  setTimeout(() => {
    if ($('[name="selling_plan"]').length > 0)
      $('[name="selling_plan"]').trigger("click");
  }, 500);
});

document.addEventListener('DOMContentLoaded', () => {
  // Target all product titles on the page
  document.querySelectorAll('.product-title-md').forEach(el => {
    el.innerHTML = el.innerHTML.replace(/®/g, '<span class="trademark">®</span>');
  });
});
